import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { TranslateModule } from '@ngx-translate/core';
import { ImageFallbackDirective } from '../core/directives/image-fallback.directive';
import { ModernSelectDirective } from '../core/directives/modern-select.directive';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    ImageFallbackDirective,
    ModernSelectDirective
  ],
  exports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    ImageFallbackDirective,
    ModernSelectDirective
  ],
  providers: []
})
export class SharedModule { }
